import { createStoreon } from 'storeon';
import { storeonDevtools } from 'storeon/devtools';
import {
  globalState,
  modelJson,
  suggestions,
  sponsoredBrands,
  cookies,
  auth,
  catalogue,
  productRedirectionUrl,
  headerDrawers,
  sponsoredProducts,
  loyaltyReducer,
  loyaltyRegistrationModalReducer,
} from '../reducers';
import { State, Events } from './types';

export const createStore = () =>
  createStoreon<State, Events>([
    ...modelJson,
    ...globalState,
    suggestions,
    sponsoredBrands,
    cookies,
    auth,
    catalogue,
    productRedirectionUrl,
    headerDrawers,
    sponsoredProducts,
    loyaltyReducer,
    loyaltyRegistrationModalReducer,
    !__IS_SERVER__ && process.env.NODE_ENV !== 'production' && storeonDevtools,
  ]);
